module.exports = __webpack_public_path__ + "static/media/DC_O_Embroidery_Bicocca_DKGrey_White.48a7d7ff.png";